var _ellipse, _path, _path2, _path3, _path4, _rect, _path5, _rect2, _path6, _path7, _circle, _path8, _rect3, _rect4, _rect5, _rect6, _rect7;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgContentmeans(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 28,
    viewBox: "0 0 40 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 14,
    cy: 14,
    rx: 14,
    ry: 14,
    fill: "#99CCFF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.5 5C24.5 4.17157 25.1716 3.5 26 3.5H31C31.2761 3.5 31.5 3.72386 31.5 4C31.5 4.82843 32.1716 5.5 33 5.5H33.4821C34.0337 5.5 34.4771 5.9541 34.464 6.50552L34.0466 24.0357C34.0272 24.85 33.3616 25.5 32.5471 25.5H26C25.1716 25.5 24.5 24.8284 24.5 24V5Z",
    fill: "white",
    stroke: "#333333"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5 5C19.5 4.17157 20.1716 3.5 21 3.5H26C26.2761 3.5 26.5 3.72386 26.5 4C26.5 4.82843 27.1716 5.5 28 5.5H28.4821C29.0337 5.5 29.4771 5.9541 29.464 6.50552L29.0466 24.0357C29.0272 24.85 28.3616 25.5 27.5471 25.5H21C20.1716 25.5 19.5 24.8284 19.5 24V5Z",
    fill: "white",
    stroke: "#333333"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5 5C14.5 4.17157 15.1716 3.5 16 3.5H21C21.2761 3.5 21.5 3.72386 21.5 4C21.5 4.82843 22.1716 5.5 23 5.5H23.4821C24.0337 5.5 24.4771 5.9541 24.464 6.50552L24.0466 24.0357C24.0272 24.85 23.3616 25.5 22.5471 25.5H16C15.1716 25.5 14.5 24.8284 14.5 24V5Z",
    fill: "white",
    stroke: "#333333"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.5 4C9.5 3.17157 10.1716 2.5 11 2.5H15.5C16.0484 2.5 16.5 2.95281 16.5 3.50898C16.5 4.5998 17.3836 5.5 18.4821 5.5C19.0337 5.5 19.4771 5.9541 19.464 6.50552L19.0466 24.0357C19.0272 24.85 18.3616 25.5 17.5471 25.5H11C10.1716 25.5 9.5 24.8284 9.5 24V4Z",
    fill: "white",
    stroke: "#333333"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 9.5,
    y: 5.5,
    width: 28,
    height: 20,
    rx: 1.5,
    fill: "white",
    stroke: "#333333"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.9572 21.8395C28.0786 21.8699 28.1993 21.8767 28.3151 21.8634C28.3863 22.082 28.4741 22.293 28.577 22.4951C28.4857 22.5675 28.4051 22.6577 28.3407 22.7651L28.2346 22.9419C27.9985 23.3354 28.0605 23.839 28.385 24.1635L28.8364 24.6149C29.1609 24.9394 29.6646 25.0014 30.0581 24.7653L30.2348 24.6593C30.3422 24.5948 30.4324 24.5143 30.5048 24.4229C30.7069 24.5259 30.9181 24.6137 31.1367 24.6849C31.1233 24.8006 31.1302 24.9212 31.1605 25.0426L31.2105 25.2425C31.3218 25.6877 31.7218 26 32.1807 26L32.8191 26C33.278 26 33.678 25.6877 33.7892 25.2425L33.8392 25.0426C33.8696 24.9212 33.8764 24.8005 33.8631 24.6848C34.0816 24.6137 34.2926 24.5259 34.4946 24.423C34.567 24.5143 34.6572 24.5948 34.7645 24.6592L34.9413 24.7653C35.3348 25.0014 35.8384 24.9394 36.1629 24.6149L36.6143 24.1635C36.9388 23.839 37.0008 23.3353 36.7647 22.9419L36.6587 22.7651C36.5943 22.6578 36.5138 22.5676 36.4225 22.4952C36.5255 22.2931 36.6133 22.082 36.6845 21.8633C36.8004 21.8767 36.9211 21.8699 37.0427 21.8395L37.2427 21.7895C37.6878 21.6782 38.0001 21.2783 38.0001 20.8194L38.0001 20.181C38.0001 19.7221 37.6878 19.3221 37.2427 19.2108L37.0427 19.1608C36.9212 19.1305 36.8004 19.1236 36.6845 19.137C36.6134 18.9185 36.5256 18.7074 36.4227 18.5053C36.5141 18.4329 36.5947 18.3426 36.6592 18.2352L36.7652 18.0584C37.0013 17.665 36.9393 17.1613 36.6148 16.8368L36.1634 16.3854C35.8389 16.0609 35.3353 15.9989 34.9418 16.235L34.765 16.3411C34.6576 16.4055 34.5674 16.4861 34.495 16.5775C34.2929 16.4745 34.0817 16.3866 33.8631 16.3154C33.8764 16.1997 33.8696 16.0791 33.8392 15.9578L33.7892 15.7578C33.678 15.3126 33.278 15.0003 32.8191 15.0003L32.1807 15.0003C31.7218 15.0003 31.3218 15.3126 31.2105 15.7578L31.1605 15.9578C31.1302 16.0791 31.1233 16.1997 31.1367 16.3154C30.9181 16.3865 30.707 16.4744 30.5049 16.5773C30.4325 16.486 30.3423 16.4055 30.235 16.3411L30.0582 16.235C29.6647 15.9989 29.1611 16.0609 28.8366 16.3854L28.3852 16.8368C28.0607 17.1613 27.9987 17.6649 28.2348 18.0584L28.3409 18.2352C28.4053 18.3425 28.4858 18.4327 28.5771 18.5051C28.4741 18.7072 28.3862 18.9183 28.3151 19.137C28.1993 19.1236 28.0786 19.1305 27.9572 19.1608L27.7572 19.2108C27.3121 19.3221 26.9998 19.7221 26.9998 20.181L26.9998 20.8194C26.9998 21.2783 27.3121 21.6782 27.7572 21.7895L27.9572 21.8395ZM29.7778 16.9999L30.8484 17.6423C31.096 17.4989 31.3641 17.3867 31.6471 17.3112L31.9499 16.1001L33.0499 16.1001L33.3527 17.3114C33.6356 17.3869 33.9036 17.4991 34.1512 17.6425L35.2221 16.9999L35.9999 17.7777L35.3573 18.8487C35.5007 19.0964 35.6128 19.3643 35.6883 19.6472L36.8999 19.9501L36.8999 21.0501L35.6883 21.353C35.6128 21.6358 35.5007 21.9037 35.3574 22.1512L36.0002 23.2226L35.2224 24.0004L34.1511 23.3576C33.9036 23.501 33.6356 23.6132 33.3527 23.6887L33.0499 24.9002L31.9499 24.9002L31.647 23.6888C31.3641 23.6134 31.096 23.5012 30.8484 23.3578L29.7775 24.0004L28.9997 23.2226L29.6421 22.1518C29.4986 21.9041 29.3864 21.636 29.3109 21.3528L28.1 21.0501L28.1 19.9501L29.3108 19.6474C29.3864 19.3642 29.4986 19.096 29.6422 18.8481L29 17.7777L29.7778 16.9999ZM32.563 18.5404C33.6802 18.5404 34.5859 19.4461 34.5859 20.5634C34.5859 21.6806 33.6802 22.5863 32.563 22.5863C31.4457 22.5863 30.54 21.6806 30.54 20.5634C30.54 19.4461 31.4457 18.5404 32.563 18.5404ZM32.5631 19.5519C33.1217 19.5519 33.5746 20.0048 33.5746 20.5634C33.5746 21.122 33.1217 21.5749 32.5631 21.5749C32.0045 21.5749 31.5516 21.122 31.5516 20.5634C31.5516 20.0048 32.0045 19.5519 32.5631 19.5519Z",
    fill: "#333333"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 24.5,
    y: 14.5,
    width: 10,
    height: 8,
    rx: 1.5,
    fill: "white",
    stroke: "#333333"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M21.6777 14C21.6777 19.2467 17.4244 23.5 12.1777 23.5C6.93103 23.5 2.67773 19.2467 2.67773 14C2.67773 8.75329 6.93103 4.5 12.1777 4.5C17.4244 4.5 21.6777 8.75329 21.6777 14Z",
    fill: "#333333",
    stroke: "#333333"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1982 20.5H13.8018V10.7969H10.1982V20.5ZM12 10.2607C13.0195 10.2607 13.793 9.52246 13.793 8.55566C13.793 7.58887 13.0195 6.85059 12 6.85059C10.9805 6.85059 10.207 7.58887 10.207 8.55566C10.207 9.52246 10.9805 10.2607 12 10.2607Z",
    fill: "white"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 33,
    cy: 10,
    r: 2,
    fill: "#333333"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23 9C23 8.72386 23.2239 8.5 23.5 8.5H26.5C26.7761 8.5 27 8.72386 27 9C27 9.27614 26.7761 9.5 26.5 9.5H23.5C23.2239 9.5 23 9.27614 23 9ZM28 9C28 8.72386 28.2239 8.5 28.5 8.5H29.5C29.7761 8.5 30 8.72386 30 9C30 9.27614 29.7761 9.5 29.5 9.5H28.5C28.2239 9.5 28 9.27614 28 9ZM26.5 10.5C26.2239 10.5 26 10.7239 26 11C26 11.2761 26.2239 11.5 26.5 11.5H29.5C29.7761 11.5 30 11.2761 30 11C30 10.7239 29.7761 10.5 29.5 10.5H26.5Z",
    fill: "#333333"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 26,
    y: 16,
    width: 7,
    height: 1,
    rx: 0.5,
    fill: "#333333"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 26,
    y: 18,
    width: 3,
    height: 1,
    rx: 0.5,
    fill: "#333333"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 26,
    y: 20,
    width: 3,
    height: 1,
    rx: 0.5,
    fill: "#333333"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 30,
    y: 18,
    width: 3,
    height: 1,
    rx: 0.5,
    fill: "#333333"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 30,
    y: 20,
    width: 3,
    height: 1,
    rx: 0.5,
    fill: "#333333"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContentmeans);
export default __webpack_public_path__ + "static/media/Contentmeans.69d80f3bfa35fb0bca3809ed152de7b6.svg";
export { ForwardRef as ReactComponent };